import { sortModelsByPriority } from "@frontend-shared/models/model-display-priority";
import { useQuery } from "@tanstack/react-query";

import { mapApiModelToUIModel } from "@/api/parsers/modelParser";
import { modelsApi } from "@/api/services";
import { useAuth } from "@/hooks/use-auth";

export const MODELS_QUERY_KEY = "models";

export const useModels = () => {
  // NOTE: NSAI-4360 — `enabled` is now resolved per-project visibility, so the
  // /models response is project-scoped (the apiClient sends the current project
  // header). Include the project uuid in the key so switching projects refetches
  // instead of serving another project's cached visibility.
  const { currentProjectUuid } = useAuth();

  return useQuery({
    queryKey: [MODELS_QUERY_KEY, currentProjectUuid],
    queryFn: () => modelsApi.getAll(),
    select: (data) => sortModelsByPriority(data.map(mapApiModelToUIModel)),
  });
};
